'use client';

import type { User } from '@/api/auth';
import { useLocalStorageStore } from '@/store';
import type { AssignABTestVersionParams } from './assignABTestVersion';
import { getCmsScaledVersion } from './getCmsScaledVersion';

export const checkAbTestVersion = ({
  user,
  experiment,
  cmsABTests,
  versions,
}: AssignABTestVersionParams) => {
  if (typeof window === 'undefined') return;

  const versionsNames = versions.map(({ name }) => name);

  const scaledVersion = getCmsScaledVersion(
    experiment,
    versionsNames,
    cmsABTests
  );
  if (scaledVersion) return scaledVersion;

  const userGropVersion = checkUserGroupsABVersion(versionsNames, user);
  const lsVersion = checkLocalStorageABVersion(versionsNames, experiment);

  if (userGropVersion) return userGropVersion;
  if (lsVersion) return lsVersion;
};

export const checkUserGroupsABVersion = (
  versionsNames: string[],
  user?: User
) => {
  if (!user?.statuses) return;

  const userGropVersion = user?.statuses.find((status) =>
    versionsNames.find((name) => name === status.id)
  );

  return userGropVersion?.id;
};

const checkLocalStorageABVersion = (
  versionsNames: string[],
  experiment: string
) => {
  const localStorageVersion = useLocalStorageStore
    .getState()
    .get<{ name: string } | null>(experiment, null)?.name;

  const savedExperiment = versionsNames.find(
    (name) => name === localStorageVersion
  );

  return savedExperiment;
};
